export default __webpack_public_path__ + "static/media/gallery_03.39c0453a.jpg";